import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const pageDataContext = /*#__PURE__*/React.createContext(undefined);
function ModulesContainerBase(_ref) {
  let {
    children,
    data
  } = _ref;
  const memoizedData = React.useMemo(() => {
    return data;
  }, [data]);
  return /*#__PURE__*/_jsx(pageDataContext.Provider, {
    value: memoizedData,
    children: children
  });
}
function useModules() {
  const ctx = React.useContext(pageDataContext);
  if (!ctx) {
    throw new Error('useModules must be used within a ModulesContainer');
  }
  return ctx;
}
const ModulesContainer = /*#__PURE__*/React.memo(ModulesContainerBase);
export { ModulesContainer, useModules as useModulesStore, pageDataContext as ModulesContext };